<script>
  import VueElementLoading from 'vue-element-loading'
  import { pluralizeMethods } from '@state/helpers'

  export default {
    components: {
      VueElementLoading,
    },
    model: {
      prop: 'value',
    },
    props: {
      value: {
        type: null,
        default: null
      },
      finishedLoading: {
        type: Boolean,
        required: true
      },
      type: {
        type: String,
        default: 'Document'
      },
      extraClasses: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        bgColour: 'bg-col-gray-2',
        bindings: {},
      }
    },
    computed: {
      historiesCount(){
        if (!this.finishedLoading || !(this.value.length > 0)){
          return 0
        }
        return this.value.length
      },
      orderedBindings(){
        if (! this.bindings){
          return []
        }
        return Object.keys(this.bindings).sort( (firstEl, secondEl) => {
          const score1 = this.resolveTypeOrderedIndex(firstEl)
          const score2 = this.resolveTypeOrderedIndex(secondEl)
          return (score1 - score2)
        });
      }
    },
    watch: {
      historiesCount(newVal, oldVal){
        this.updateBindings()
      },
    },
    async created() {
      this.updateBindings();
    },
    methods: {
      ...pluralizeMethods,
      generateLink(nav){
        const ce = this.$createElement
        const item = this.parsNavToItem(nav)
        let params = {};
        if (this.isProjectDocument(nav)) {
          params = { id: nav.project }
        }
        const routerObject = {
          props: { to: {}},
          class: ""
        }
        routerObject.props.to = this.resolveRouterObjectForDocument(item, params);
        routerObject.class="tx-td-underline tx-col-black"
        return ce('b-link', routerObject, `${nav.label}`);
      },
      parsNavToItem(nav){
        const item = {}
        item.type = this.resolveDocumentKeyForSnakeCase(nav.key)
        item.documentId = nav.id
        return item
      },
      isProjectDocument(nav){
        if (nav && nav.key && ['invoice_order','purchase_order','quote','sale_order'].indexOf(nav.key) !== -1 ){
          return true
        }
        return false
      },
      updateBindings(){
        this.value.forEach(historyEl => {
          if (historyEl.navigate_params && historyEl.navigate_params.length > 0){
            historyEl.navigate_params.forEach(el => {
              const key = this.resolveTypeForDocument(this.resolveDocumentKeyForSnakeCase(el.key))
              const uid = el.label
              const payload = el
              if (Object.prototype.hasOwnProperty.call(this.bindings, key)){
                const type = this.bindings[key]

                if(! Object.prototype.hasOwnProperty.call(type, uid)){
                  type[uid] = payload
                }
              }else{
                const newType = {}
                newType[uid] = payload
                this.bindings[key] = newType
              }
            })
          }
        });
      }
    }
  }
</script>

<template>
  <section>
    <section v-if="value && value.length > 0" class="fl-left tw-flex tw-flex-wrap">
      <div v-for="(binding, index) in orderedBindings" :key="index" class="pd-x-10">
        <span class="tx-col-black">{{pluralize( binding, (bindings[binding]).size )}}</span>
        <ul class="mg-b-u tw-list-disc pl-5">
          <li v-for="(object, index2) in bindings[binding]" :key="index2">
            <BaseCreateElement :nodes="generateLink(object)" />
          </li>
        </ul>
      </div>
    </section>
    <VueElementLoading v-else-if="!finishedLoading" :active="!(value && value.length > 0)" />
  </section>
</template>
